import React, { useState } from "react";
import { TwitterPicker } from 'react-color';
import './NewPlayerForm.css';

export default function NewPlayerForm(props) {
  // Set default new player name to a blank string
  // Note this state is only needed in this module, so it lives here
  const [newPlayer, setNewPlayer] = useState("");
  const [color, setColor] = useState("#888");

  function handleSubmit(event) {
    // This stops the page refreshing
    event.preventDefault();
    // This stops blank entries from being enterable
    if (newPlayer !== "") {
      props.addPlayer(newPlayer, color);
    }
    // This clears the entry box after entry
    setNewPlayer("");
  }

  function handleNewPlayer(event) {
    setNewPlayer(event.target.value);
  }
  return (
    <>
      <form onSubmit={handleSubmit} className="player-form">
        <div classname="FlexDiv">
          <label htmlFor="name" className="AddLabel">Player </label>
        <input
          value={newPlayer}
          onChange={handleNewPlayer}
          type="text"
          id="name"
          style = {{color}}
        />
        <button className="button">Add</button>
        </div>
        <div className = "pickerContainer">
        <TwitterPicker 
          color={color}
          onChangeComplete = { (color) => {setColor (color.hex)}} 
          triangle = "hide"/>
        </div>
      </form>
    </>
  );
}
